<form [formGroup]="craftEntityForm">
  <div class="row">
    <div class="col-lg-6 mb-3">
      <input-field
        [label]="'Code'"
        [type]="'text'"
        [placeholder]="'Enter code'"
        formControlName="code"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Code is required'"
      >
      </input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <input-field
        [label]="'Description'"
        [type]="'text'"
        [placeholder]="'Enter description'"
        formControlName="description"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Description is required'"
      >
      </input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <generic-dropdown
        [items]="typeList()"
        [label]="'Type'"
        [allowSearch]="true"
        [clearable]="true"
        [required]="true"
        [placeholder]="'Select Type'"
        [errormessage]="'Type is required'"
        formControlName="type"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-6 mb-3">
      <generic-dropdown
        [items]="taskList() ?? []"
        [label]="'Task'"
        [allowSearch]="true"
        [clearable]="true"
        [placeholder]="'Select Task'"
        formControlName="taskId"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-6 mb-3">
      <generic-dropdown
        [items]="jobTypeList() ?? []"
        [label]="'Job Type'"
        [allowSearch]="true"
        [clearable]="true"
        [placeholder]="'Select Job Type'"
        formControlName="jobTypeId"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-6 mb-3">
      <generic-dropdown
        [items]="majorCodeList.value()"
        [label]="'Major Code'"
        [allowSearch]="true"
        [clearable]="true"
        [placeholder]="'Select Major Code'"
        formControlName="majorCodeId"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-6 mb-3">
      <generic-dropdown
        [items]="minorCodeList.value()"
        [label]="'Minor Code'"
        [allowSearch]="true"
        [clearable]="true"
        [placeholder]="'Select Minor Code'"
        formControlName="minorCodeId"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-6 mb-3">
      <generic-dropdown
        [items]="unitOfMeasureList()"
        [label]="'Unit of Measure'"
        [allowSearch]="true"
        [clearable]="true"
        [placeholder]="'Select Unit of Measure'"
        formControlName="unitOfMeasureId"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-6 mb-3">
      <input-field
        [label]="'Retention Percent'"
        [type]="'text'"
        [placeholder]="'Enter retention percent'"
        formControlName="retentionPercent"
        [requiredLabel]="true"
        [required]="true"
        [type]="'number'"
        [errormessage]="'Retention Percent is required'"
      >
      </input-field>
    </div>
    <!-- <label for="autoUpdate">Auto Update</label>
    <div class="col-lg-6 mb-3"><p-toggleswitch formControlName="autoUpdate"></p-toggleswitch></div> -->
  </div>
</form>
